/**
 * NEEDS OPTIMIZATIONS IN RENDERING SELECTION OPTIONS
 */
import { LinearGradient } from 'expo-linear-gradient';
import React, { useEffect, useRef } from 'react';
import {
  FlatList,
  StyleProp,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

import generateID from '../../utils/generate-id';

type SelectProps = {
  accessibilityLabel?: string;
  value: string;
  onSelect?: (value: string) => void;
  options: { label: string; value: string }[];
  style?: StyleProp<ViewStyle>;
  optionStyle?: StyleProp<ViewStyle>;
  id?: string;
};

const OPTION_HEIGHT = 32;

const Select = (props: SelectProps) => {
  const flatListRef = useRef<FlatList | null>();

  useEffect(() => {
    if (flatListRef.current) {
      const index = props.options.findIndex(
        (option) => option.value === props.value
      );

      flatListRef.current.scrollToIndex({ index: index > -1 ? index : 0 });
    }
  }, [props.value, flatListRef.current]);

  return (
    <View style={props.style}>
      <FlatList
        accessibilityLabel={props.accessibilityLabel}
        ref={(ref) => (flatListRef.current = ref)}
        data={props.options}
        extraData={props.value}
        renderItem={({ item }) => (
          <TouchableOpacity onPress={() => props.onSelect?.(item.value)}>
            <Text
              style={[
                style.option,
                props.optionStyle && props.optionStyle,
                item.value === props.value && style.optionSelected,
              ]}
            >
              {item.label}
            </Text>
          </TouchableOpacity>
        )}
        keyExtractor={(_, index) => index.toString()}
        getItemLayout={(_, index) => ({
          length: OPTION_HEIGHT,
          offset: OPTION_HEIGHT * index,
          index,
        })}
        style={style.flatList}
        contentContainerStyle={style.flatListContent}
        removeClippedSubviews
        maxToRenderPerBatch={7}
        /** Generate HTML and Test IDs  */
        {...generateID(props.id)}
      />
      <LinearGradient
        pointerEvents="none"
        colors={['white', 'rgba(255, 255, 255, 0)', 'white']}
        style={StyleSheet.absoluteFill}
      />
    </View>
  );
};

const style = StyleSheet.create({
  flatList: {
    height: 204,
    backgroundColor: 'transparent',
  },
  flatListContent: {
    marginVertical: 88,
  },
  option: {
    paddingHorizontal: 16,
    paddingVertical: 4,
    height: OPTION_HEIGHT,
    textAlign: 'center',
    borderRadius: 4,
  },
  optionSelected: {
    backgroundColor: '#EEF0F2',
  },
});

export default Select;
